<div [class]="className.tabDivParent">
  <div *ngFor="let tab of tabs" [class]="className.tabDiv">
    <div
      (click)="action.emit({type: 'tab', group: 'tab', data: tab })"
      [ngClass]="tab.path === selectedTab ? className.tabActive: className.tabNormal"
      [class]="className.tab"
    >
      {{ tab.name }}
    </div>
  </div>
</div>
